import styled from "styled-components";
import RoyMessage from "./RoyMessage";
import FadeIn from "react-fade-in";
import { WELCOME_DELAY, WELCOME_TRANSITION_DURATION } from "../../../../constants/index";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { keyframes } from "styled-components";
import { useCookies } from "react-cookie";

const breathAnimation = keyframes`
 0% {opacity:1;}
 100% {opacity: 0;}
`;

const royAnimation = (y) => keyframes`
100%{transform: translateX(${y}px);}
`;

const bottomRight = keyframes`
to {
  transform: translate(76vw, 40vh ) scale(0.5);
}
`;

const AnimationWrapper = styled.div`
  display: flex;
  .hide-paragraph {
    animation-name: ${breathAnimation};
    animation-delay: 4.5s;
    animation-duration: 1.5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-all;
    @media all and (max-width: 1439px) {
      min-height: 165px;
    }
  }

  .welcome-roy-icon {
    /* animation: ${(props) => royAnimation(props.royLeftDistance)} 1.5s ${(props) => props.duration}s forwards; */

    animation: ${(props) => royAnimation(props.royLeftDistance)} 1.5s ${(props) => props.duration}s forwards,
      ${bottomRight} 1s 17s forwards;
  }
`;

const OnBoarding4 = (props) => {
  const history = useHistory();
  const [royTime, setRoyTime] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies([]);
  const animationEndMethod = (e) => {
    setRoyTime(royTime + 1);
    setStartRoy(true);
    if (royTime === 8) {
      if (cookies["appName"] !== "workbench" && cookies["appName"] !== "xiQ WB") {
        history.push("/content/search"); // redirecting to Smart Content as required in WB 4.0
      } else {
        history.push("content/search"); // redirecting user to smart content for first time
      }
    }
  };

  const [startRoy, setStartRoy] = useState(false);
  const [centerDistance, setCenterDistance] = useState(0);
  const royRef = useRef(null);

  // calculate animation distance and other values
  const duration = 5;
  // distance to the center
  // half screen - distance of object to left - plus half the width of object

  const getLeftDistance = () => {
    if (royRef != null) {
      const rect = royRef.current.getBoundingClientRect();
      let top = rect.top + document.body.scrollTop;
      let left = rect.left + document.body.scrollLeft;
      setCenterDistance(window.innerWidth / 2 - left - 50);
    }
  };

  useEffect(() => {
    getLeftDistance();
  }, []);

  return (
    <div className="onBoarding">
      <FadeIn delay={WELCOME_DELAY} transitionDuration={WELCOME_TRANSITION_DURATION}>
        <div className="welcome-text fourth-intro ">
          <div className="d-flex max-width-75">
            <AnimationWrapper royLeftDistance={centerDistance} duration={duration}>
              <div
                ref={royRef}
                onAnimationEnd={(e) => animationEndMethod(e)}
                className="welcome-roy-icon"
                style={{ position: "relative" }}
              >
                {!startRoy ? (
                  <RoyMessage id="TEST_ONLINE" active={false} />
                ) : (
                  <>
                    <RoyMessage active={true} />
                  </>
                )}{" "}
              </div>
              <div className="heading">
                <h4 className="hide-paragraph">
                  All powered by xiQ’s <span className="green-text">SmartContent AI engine</span> that finds,
                  refines & targets content for your audience
                </h4>
              </div>
            </AnimationWrapper>
          </div>
        </div>
      </FadeIn>
    </div>
  );
};

export default OnBoarding4;
